export const dashboardSteps = () => [
  {
    target: '[data-tour="dashboard-filters"]',
    title: 'Dashboard Filters',
    content:
      'Filter dashboard data by project, issue type, and task status.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="project-metrics"]',
    title: 'Project Metrics',
    content:
      'View project statistics, progress, and overall health.',
  },
  {
    target: '[data-tour="work-overview"]',
    title: 'Work Overview',
    content:
      'Track workload, team activity, and ongoing work.',
  },
  {
    target: '[data-tour="task-analytics"]',
    title: 'Task Analytics',
    content:
      'Monitor task statuses, priorities, and completion trends.',
  },
];